import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import {
  Card,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  IconButton,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NameAvatarCell } from './NameAvatarCell';
import { OptionsCell } from './OptionsCell';

export function ListCards({
  showSkeleton,
  data,
  forwardedRef,
  onEdit,
  onResend,
  onDelete,
}) {
  return (
    <>
      {data?.users?.map(user => (
        <UserCard
          key={user.personId}
          user={user}
          onEdit={() => onEdit(user)}
          onResend={() => onResend(user)}
          onDelete={() => onDelete(user)}
        />
      ))}
      {showSkeleton && <UserCardLoading forwardedRef={forwardedRef} />}
      {showSkeleton &&
        Array.from({ length: 6 }).map((_item, index) => (
          <UserCardLoading key={index} />
        ))}
    </>
  );
}

function UserCardLoading({ forwardedRef }) {
  return (
    <Card ref={forwardedRef}>
      <CardContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={1}
        >
          <Skeleton variant="circular" width="40px" height="40px" />
          <Skeleton variant="text" sx={{ flexGrow: 1 }} />
        </Stack>
      </CardContent>
      <Divider />
      <CardActions sx={{ justifyContent: 'center' }}>
        <Skeleton width="40px" />
      </CardActions>
    </Card>
  );
}

export function UserCard({ user, onEdit, onResend, onDelete }) {
  const { t } = useTranslation('users');
  const [open, setOpen] = useState();
  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <NameAvatarCell user={user} />
          <OptionsCell
            user={user}
            onEdit={onEdit}
            onResend={onResend}
            onDelete={onDelete}
          />
        </Stack>
      </CardContent>
      <Divider />
      <CardActions sx={{ p: 0 }}>
        <IconButton
          sx={{
            width: '100%',
            borderRadius: '0px',
            padding: '4px',
          }}
          aria-label="show more"
          onClick={() => setOpen(!open)}
        >
          {(!open && <KeyboardArrowDown />) || <KeyboardArrowUp />}
        </IconButton>
      </CardActions>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Stack gap={0.75} px={3} py={2}>
          <Stack direction="row" gap={0.5} alignItems="center">
            <Typography variant="subtitle2">{t('table.email')}:</Typography>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
          </Stack>
          <Stack direction="row" gap={0.5} alignItems="center">
            <Typography variant="subtitle2">{t('table.phone')}:</Typography>
            <Typography variant="body2" color="text.secondary">
              {user.phone}
            </Typography>
          </Stack>
          <Stack direction="row" gap={0.5} alignItems="center">
            <Typography variant="subtitle2">{t('table.level')}:</Typography>
            <Typography variant="body2" color="text.secondary">
              {user.title}
            </Typography>
          </Stack>
          <Stack direction="row" gap={0.5} alignItems="center">
            <Typography variant="subtitle2">{t('table.role')}:</Typography>
            <Typography variant="body2" color="text.secondary">
              {user.roles?.map(rol => rol.name).join(', ')}
            </Typography>
          </Stack>
        </Stack>
      </Collapse>
    </Card>
  );
}
